import type React from "react";
import {memo, useCallback} from "react";

import {Button} from "../ui/button";

import type {QuickSelectDate} from "./type";

type Props = {
    day: QuickSelectDate;
    onQuickSelectDate: (day: QuickSelectDate) => void;
};

const QuickSelectDateButton: React.FC<Props> = ({day, onQuickSelectDate}) => {
    const onPress = useCallback(() => {
        onQuickSelectDate(day);
    }, [onQuickSelectDate, day]);

    return (
        <Button no110MinWidth action="default" variant="ghost" onPress={onPress}>
            {day.name}
        </Button>
    );
};

export default memo(QuickSelectDateButton);
